export default __webpack_public_path__ + "static/media/close-x.2791559a.svg";